import { AssessmentStatus } from './assessment-status';
import { BaseEntity } from './base-entity';
import { AssessmentDistributionMemberData } from './assessment-distribution-member-data';

export class AssessmentSummary extends BaseEntity {
  totalRiskCount: number;
  completedRiskCount: number;
  estimatedTimeMinutes: number;
  dueDate: Date;
  status: AssessmentStatus;
  surveyTarget: BaseEntity;
  rank: number;
  description: string;
  surveyMembers: Array<AssessmentDistributionMemberData>;
  percentInt: number;
  riskFormula: BaseEntity;
  parent: BaseEntity;
}
